import React, { useEffect, useState } from "react"
import { Button, Label, Modal, Pagination, Table } from "semantic-ui-react";
import useQuery from "../../useQuery";
import { loadState } from "../../sdk/util/loadState";
import Typeahead from "../Typeahead/Typeahead";
import shop from "shop/shop"
import CSVDownloader from "./CSVDownloader";
import CSVUploader from "./CSVUploader";

function SortimentModal( { products, open, onClose } ) {
  let changesByProductId = {}
  
  const ITEMS_PER_PAGE = 10
  const [page, setPage] = useState( 0 )
  const [additionalProducts, setAdditionalProducts] = React.useState( [] )
  const [loadedProducts, setProducts] = useState( [] )
  const [loading, setLoading] = useState( false )
  
  const [_changes, setChanges] = useState( [] )
  _changes.map( change => {
    changesByProductId[ change.map_id ] = change
  } )
  
  const productsWithAdditions = [...additionalProducts, ...products]
  let changes = Object.values( changesByProductId )
  const productsPage = (productsWithAdditions || []).slice( page * ITEMS_PER_PAGE, (page + 1) * ITEMS_PER_PAGE )
  
  const [previewProduct, setPreviewProduct] = React.useState( false )
  const [typeaheadKey, setTypeaheadKey] = React.useState( Math.random() )
  
  const addProduct = ( { product } ) => {
    console.log( "ADD", product )
    setAdditionalProducts( [product, ...additionalProducts] )
    setChanges( [...changes, { ...product, command: "add" }] )
  }
  const removeProduct = ( { product } ) => {
    console.log( "REMOVE", product )
    setAdditionalProducts( [product, ...additionalProducts] )
    setChanges( [...changes, { ...product, command: "remove" }] )
  }
  
  const tblName = shop.session.handUser.extras.selections
  
  const applyChanges = async () => {
    setLoading( true )
    // changes
    let p = changes.map( change => {
      let out
      let data
      switch (change.command) {
        case "add":
          data = [{ "id": change.map_id, "articleid": change.map_id }];
          out = shop.fetch( `/shop/rest/tables/data/${tblName}`, { credentials: 'include', method: 'POST', body: JSON.stringify( data ) } );
          break;
        case "remove":
          data = { "articleid": { "equals": change.map_id } }; // --> SQL => WHERE articleid LIKE '12%'
          out = shop.fetch( `/shop/rest/tables/data/${tblName}?filter=` + encodeURIComponent( JSON.stringify( data ) ), { credentials: 'include', method: 'DELETE' } )
          break;
      }
      return out
    } )
    let results = await Promise.all( p )
    setLoading( false )
    setAdditionalProducts( [] )
    setChanges( [] )
    console.log( { results } )
    onClose()
  }
  
  useEffect( () => {
    if ( !productsPage ) return
    setLoading( true )
    shop.products.list( productsPage.map( i => i.id || i.map_id ) )
      .then( products => {
        console.log( { products } )
        setProducts( products )
        setLoading( false )
      } )
  }, [page, products, additionalProducts] )
  
  if ( !products ) return <Button loading/>
  
  return <Modal open={open} onClose={onClose} size={"large"}>
    <Modal.Header>
      <div className="flex flex-row justify-between items-center">
        <div>{translate( "Sortiment" )}</div>
        <div><Button basic circular icon={"close"} onClick={onClose}/></div>
      </div>
    </Modal.Header>
    <Modal.Content>
      
      <Table compact={"very"}>
        
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{translate( "Artikel" )}</Table.HeaderCell>
            <Table.HeaderCell>{translate( "Beschreibung" )}</Table.HeaderCell>
            <Table.HeaderCell>{translate( "Hersteller" )}</Table.HeaderCell>
            <Table.HeaderCell>&nbsp;</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan={4}>
              <div className="flex flex-row">
                <div className="w-100 pr2">
                  <Typeahead key={typeaheadKey} onSelectProduct={setPreviewProduct}/>
                </div>
                <div className="flex flex-row justify-end">
                  {/*<Button size={"tiny"} basic>{translate( "zurücksetzen" )}</Button>*/}
                  <Button size={"tiny"} disabled={!previewProduct}
                          onClick={() => {
                            previewProduct && addProduct( previewProduct )
                            setPreviewProduct( false )
                            setTypeaheadKey( Math.random() )
                          }} primary>{translate( "hinzufügen" )}</Button>
                  <Button color="red" size={"tiny"} disabled={!previewProduct}
                          onClick={() => {
                            previewProduct && removeProduct( previewProduct )
                            setPreviewProduct( false )
                            setTypeaheadKey( Math.random() )
                          }} >{translate( "entfernen" )}</Button>
                </div>
              </div>
            
            </Table.Cell>
          </Table.Row>
          {loadedProducts.map( product => {
            const change = changesByProductId[ product.map_id ]
            const isAdded = change && change.command === "add"
            const isRemoved = change && change.command === "remove"
            return <Table.Row key={product.map_id} negative={isRemoved} positive={isAdded}>
              <Table.Cell>
                <a href={`/product/${product.map_id}/`} target={"_blank"}>
                  <span className={`b black-70 ${isRemoved ? "strike" : ""}`}>
                    <span className="dib pr1" style={{ width: "42px" }}>
                      <img width={42} src={product.img_src_small} alt=""/>
                    </span> {product.map_id}
                  </span>
                </a>
              </Table.Cell>
              <Table.Cell><span className={`b f7 black-70 ${isRemoved ? "strike" : ""}`}>{product.desc.des || "..."}</span></Table.Cell>
              <Table.Cell><span className={`b f7 black-70 ${isRemoved ? "strike" : ""}`}>{product.extraText.Z_Hersteller || "..."}</span></Table.Cell>
              <Table.Cell>
                <div className="flex flex-row justify-end">
                  {/*<Button onClick={() => { setProductId(product.map_id)}} size={"tiny"} basic>VIEW</Button>*/}
                  {!change && <Button size={"tiny"} basic onClick={() => {
                    setChanges( [...changes, { ...product, command: "remove" }] )
                  }}>{translate( "entfernen" )}</Button>}
                  {change && <Button size={"tiny"} basic onClick={() => {
                    setChanges( [...changes.filter( c => c.map_id !== product.map_id )] )
                  }}>{translate( isRemoved ? "wiederherstellen" : "entfernen" )}</Button>}
                  
                  {/*<div>
                    {(!isRemoved && !isAdded) && <Button basic icon={"circle"}/>}
                    {isRemoved && <Button basic color="red" icon={"circle"}/>}
                    {isAdded && <Button basic color="green" icon={"circle"}/>}
                </div>*/}
                </div>
              </Table.Cell>
            
            </Table.Row>
          } )}
        </Table.Body>
      </Table>
      
      <div>
        <Pagination
          onPageChange={( e, page ) => {
            console.log( "PAGE", page.activePage )
            setPage( page.activePage - 1 )
          }}
          boundaryRange={0}
          defaultActivePage={1}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          siblingRange={1}
          totalPages={Math.ceil( products.length / ITEMS_PER_PAGE )}
        />
      </div>
    
    </Modal.Content>
    <Modal.Actions>
      <div className="flex flex-row items-center">
        <div className="f4 b black-60">{changes.length} {translate("Änderungen")}</div>
        <div className="ml-auto">
          <Button loading={loading} onClick={onClose}>{translate("Zurück")}</Button>
          <Button
            onClick={applyChanges}
            loading={loading} primary={changes.length > 0} disabled={!changes.length}>{translate("Speichern")}</Button>
        </div>
      </div>
    </Modal.Actions>
  </Modal>
}


export default function SortimentManager( { customerId, backLink = "/account/budgets" } ) {
  const query = useQuery()
  const [loading, setLoading] = useState()
  const tblName = shop.session.handUser.extras.selections
  const [open, setOpen] = useState( false )
  const [sortiment, setSortiment] = useState( false )
  useEffect( loadState( setSortiment, `/shop/rest/tables/data/${tblName}?start=0&count=1200`, customerId, { method: "GET" } ), [customerId] )
  
  return <div className="BudgetManager">
    {/*<h2>{translate( "Sortiment" )} ({sortiment && sortiment.length})</h2>*/}
    <SortimentModal
      onClose={() => {
        setOpen( false )
      }}
      open={open} products={sortiment}/>
    <Button size={"tiny"} basic onClick={() => {
      setOpen( true )
    }}>{translate( "Bearbeiten" )}</Button>


    <CSVDownloader></CSVDownloader>
    <CSVUploader></CSVUploader>
  </div>
}


// WEBPACK FOOTER //
// ./src/components/Budget/SortimentManager.js